import { Helmet } from 'react-helmet';
import FAQItem from './FAQItem';





const FAQItems = ({ continents }) => {
    return (
        <>
            <Helmet
                script={[
                    {
                        type: "application/ld+json",
                        innerHTML: JSON.stringify({
                            "@context": "http://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": continents?.map(item => ({
                                "@type": "Question",
                                "name": item.attributes.name,
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": item?.attributes.countries.data?.map(country => country.attributes.name)
                                }
                            }))
                        })
                    }
                ]}
            />


            <div className='faq-items'>
                {continents?.map((item, index) => (
                    <FAQItem key={index} item={item} />
                ))}
            </div>
        </>
    );
}

export default FAQItems;